export default __webpack_public_path__ + "static/media/FacilityForms.b8fe4e49.pdf";